import { render, staticRenderFns } from "./PopupCreateNotice.vue?vue&type=template&id=75539987"
import script from "./PopupCreateNotice.vue?vue&type=script&lang=js"
export * from "./PopupCreateNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports